export const DUAL_JOINT_LIST_PAGE_TEXT = {
  'NO.': 'No.',
  APPLICATION_NO: 'Application No',
  NAME: 'Name',
  ENTRY_YEAR: 'Entry Year',
  DEPARTMENT: 'Department',
  PROGRAMME: 'Programme',
  CHIEF_SUPERVISOR: 'Chief Supervisor',
  PARTNER_SUPERVISOR: 'Partner Supervisor',
  PARTNER_APPLICATION_NO: 'Partner Application No',
  PARTNER_CATEGORY: 'Partner Category',
  PARTNER: 'Partner',
  POLYU_HOME: 'PolyU Home',
  STATUS: 'Status',
  ACTION: 'Action',
  FAILED_TO_UPDATE_NOMINATION_LIST: 'Failed to update nomination list.',
  UPDATE_NOMINATION_LIST: 'Update Nomination List',
  CLOSE: 'Close',
  RECORDS: 'records',
  FAILED_UPDATE_LIST: 'Failed Update List',
  UPLOAD_NOMINATION_LIST: 'Upload Nomination List',
  VIEW_APPLICATION_DETAIL: 'View Application Detail',
  DOWNLOAD_APPLICATION_PROFILE: 'Download Profile',
  INVVALID_APPLICATIONID: 'Invalid Application Id',
  DUAL: 'Dual',
  JOint_SUPERVISION: 'Joint Supervision',
  NA: 'N/A',
  YES: 'YES',
  NO: 'NO',
  NO_INDICATION: 'Not Indicated',
};
